/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
    MonitoredObjectMetadata,
    MonitoredObjectMetadataFromJSON,
    MonitoredObjectMetadataFromJSONTyped,
    MonitoredObjectMetadataToJSON,
    MonitoredObjectType,
    MonitoredObjectTypeFromJSON,
    MonitoredObjectTypeFromJSONTyped,
    MonitoredObjectTypeToJSON,
    MonitoringDevice,
    MonitoringDeviceFromJSON,
    MonitoringDeviceFromJSONTyped,
    MonitoringDeviceToJSON,
    TemperatureSensor,
    TemperatureSensorFromJSON,
    TemperatureSensorFromJSONTyped,
    TemperatureSensorToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectNested
 */
export interface ReadOnlyMonitoredObjectNested {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    clientId: number;
    /**
     * 
     * @type {Client}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    client?: Client;
    /**
     * 
     * @type {MonitoredObjectType}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    monitoredObjectType?: MonitoredObjectType;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    monitoredObjectTypeId?: number;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    costPerKm?: object;
    /**
     * 
     * @type {MonitoredObjectMetadata}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    metadata?: MonitoredObjectMetadata;
    /**
     * 
     * @type {Array<TemperatureSensor>}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    temperatureSensors?: Array<TemperatureSensor>;
    /**
     * 
     * @type {MonitoringDevice}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    monitoringDevice?: MonitoringDevice;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    readonly deleted?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    systemDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    manufacturerName?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    _configuration?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    status?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    tankSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    customLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    vehicleTrainMaxWeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    vehicleTractorMaxWeight?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    cng?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    disabledAt?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    forwardedToDff?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    lastSyncWithDff?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    dffSyncTraceback?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    driverApplication?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    externalSystem?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectNested
     */
    countryOfRegistration?: number | null;
}

export function ReadOnlyMonitoredObjectNestedFromJSON(json: any): ReadOnlyMonitoredObjectNested {
    return ReadOnlyMonitoredObjectNestedFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectNestedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectNested {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'clientId': json['client_id'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'monitoredObjectType': !exists(json, 'monitored_object_type') ? undefined : MonitoredObjectTypeFromJSON(json['monitored_object_type']),
        'monitoredObjectTypeId': !exists(json, 'monitored_object_type_id') ? undefined : json['monitored_object_type_id'],
        'costPerKm': !exists(json, 'cost_per_km') ? undefined : json['cost_per_km'],
        'metadata': !exists(json, 'metadata') ? undefined : MonitoredObjectMetadataFromJSON(json['metadata']),
        'temperatureSensors': !exists(json, 'temperature_sensors') ? undefined : ((json['temperature_sensors'] as Array<any>).map(TemperatureSensorFromJSON)),
        'monitoringDevice': !exists(json, 'monitoring_device') ? undefined : MonitoringDeviceFromJSON(json['monitoring_device']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'registrationNumber': json['registration_number'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'systemDescription': !exists(json, 'system_description') ? undefined : json['system_description'],
        'manufacturerName': !exists(json, 'manufacturer_name') ? undefined : json['manufacturer_name'],
        '_configuration': !exists(json, 'configuration') ? undefined : json['configuration'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'tankSize': !exists(json, 'tank_size') ? undefined : json['tank_size'],
        'customLabel': !exists(json, 'custom_label') ? undefined : json['custom_label'],
        'vehicleTrainMaxWeight': !exists(json, 'vehicle_train_max_weight') ? undefined : json['vehicle_train_max_weight'],
        'vehicleTractorMaxWeight': !exists(json, 'vehicle_tractor_max_weight') ? undefined : json['vehicle_tractor_max_weight'],
        'cng': !exists(json, 'cng') ? undefined : json['cng'],
        'disabledAt': !exists(json, 'disabled_at') ? undefined : (json['disabled_at'] === null ? null : new Date(json['disabled_at'])),
        'forwardedToDff': !exists(json, 'forwarded_to_dff') ? undefined : json['forwarded_to_dff'],
        'lastSyncWithDff': !exists(json, 'last_sync_with_dff') ? undefined : (json['last_sync_with_dff'] === null ? null : new Date(json['last_sync_with_dff'])),
        'dffSyncTraceback': !exists(json, 'dff_sync_traceback') ? undefined : json['dff_sync_traceback'],
        'driverApplication': !exists(json, 'driver_application') ? undefined : json['driver_application'],
        'externalSystem': !exists(json, 'external_system') ? undefined : json['external_system'],
        'countryOfRegistration': !exists(json, 'country_of_registration') ? undefined : json['country_of_registration'],
    };
}

export function ReadOnlyMonitoredObjectNestedToJSON(value?: ReadOnlyMonitoredObjectNested | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'client': ClientToJSON(value.client),
        'monitored_object_type': MonitoredObjectTypeToJSON(value.monitoredObjectType),
        'monitored_object_type_id': value.monitoredObjectTypeId,
        'cost_per_km': value.costPerKm,
        'metadata': MonitoredObjectMetadataToJSON(value.metadata),
        'temperature_sensors': value.temperatureSensors === undefined ? undefined : ((value.temperatureSensors as Array<any>).map(TemperatureSensorToJSON)),
        'monitoring_device': MonitoringDeviceToJSON(value.monitoringDevice),
        'external_id': value.externalId,
        'registration_number': value.registrationNumber,
        'description': value.description,
        'system_description': value.systemDescription,
        'manufacturer_name': value.manufacturerName,
        'configuration': value._configuration,
        'note': value.note,
        'status': value.status,
        'tank_size': value.tankSize,
        'custom_label': value.customLabel,
        'vehicle_train_max_weight': value.vehicleTrainMaxWeight,
        'vehicle_tractor_max_weight': value.vehicleTractorMaxWeight,
        'cng': value.cng,
        'disabled_at': value.disabledAt === undefined ? undefined : (value.disabledAt === null ? null : value.disabledAt.toISOString()),
        'forwarded_to_dff': value.forwardedToDff,
        'last_sync_with_dff': value.lastSyncWithDff === undefined ? undefined : (value.lastSyncWithDff === null ? null : value.lastSyncWithDff.toISOString()),
        'dff_sync_traceback': value.dffSyncTraceback,
        'driver_application': value.driverApplication,
        'external_system': value.externalSystem,
        'country_of_registration': value.countryOfRegistration,
    };
}


